import React from 'react';
import {ClipLoader} from "react-spinners";

function Loader({size}) {
    return (
        <ClipLoader type="Oval"
                    color="#101C2A"
                    size={size}/>
    );
}

export default Loader;